import { BotMessage, FromMessageEnum, UserMessage } from 'src/types';
import { fileToDataUrl } from 'src/utils/fileToDataUrl';

export async function createUserMessage(text: string, file?: File): Promise<UserMessage> {
	let fileDataUrl: string | undefined;
	if (file) {
		fileDataUrl = await fileToDataUrl(file);
	}
	return {
		id: 'user-' + Date.now(),
		from: FromMessageEnum.USER,
		created_time: new Date().toISOString(),
		text,
		file: fileDataUrl
	};
}

export function createBotMessage(): BotMessage {
	return {
		completed: false,
		created_time: new Date().toISOString(),
		feedback: null,
		from: FromMessageEnum.BOT,
		id: 'bot-' + Date.now(),
		sources: [],
		internetSources: [],
		outdated: false,
		text: '',
		internetText: ''
	};
}
